var ScheduledItemTypes = {
    UNDEFINED: { value: 0, text: "UNDEFINED", key: "UNDEFINED" },
    CLOCK_BOX: { value: 1, text: "CLOCK_BOX", key: "CLOCK_BOX" },
    DAYTEMPLATE_CLOCK: { value: 2, text: "DAYTEMPLATE_CLOCK", key: "DAYTEMPLATE_CLOCK" },
    DAYTEMPLATE_PLAYLIST: { value: 3, text: "DAYTEMPLATE_PLAYLIST", key: "DAYTEMPLATE_PLAYLIST" },
    DAYTEMPLATE_PODCAST: { value: 4, text: "DAYTEMPLATE_PODCAST", key: "DAYTEMPLATE_PODCAST" },
    DAYTEMPLATE_PROMO: { value: 5, text: "DAYTEMPLATE_PROMO", key: "DAYTEMPLATE_PROMO" },
};
ScheduledItemTypes[0] = ScheduledItemTypes.UNDEFINED;
ScheduledItemTypes[1] = ScheduledItemTypes.CLOCK_BOX;
ScheduledItemTypes[2] = ScheduledItemTypes.DAYTEMPLATE_CLOCK;
ScheduledItemTypes[3] = ScheduledItemTypes.DAYTEMPLATE_PLAYLIST;
ScheduledItemTypes[4] = ScheduledItemTypes.DAYTEMPLATE_PODCAST;
ScheduledItemTypes[5] = ScheduledItemTypes.DAYTEMPLATE_PROMO;

var TrackTypes = {
    UNDEFINED: {
        value: 0, text: "UNDEFINED", key: "UNDEFINED",
    },
    MUSIC: { value: 1, text: "MUSIC", key: "MUSIC", icon: "fas fa-music" },
    JINGLE: { value: 2, text: "JINGLE", key: "JINGLE", icon: "fas fa-drum-steelpan" },
    PROMO: { value: 3, text: "PROMO", key: "PROMO", icon: "far fa- clock" },
    VOICE_TRACK: { value: 4, text: "VOICE_TRACK", key: "VOICE_TRACK", icon: "fas fa- microphone" },
    PODCAST: { value: 5, text: "PODCAST", key: "PODCAST", icon: "far fa- clock" },
    FILLER: {
        value: 9, text: "FILLER", key: "FILLER", icon: "fas fa-ad"
    }
};

TrackTypes[0] = TrackTypes.UNDEFINED;
TrackTypes[1] = TrackTypes.MUSIC;
TrackTypes[2] = TrackTypes.JINGLE;
TrackTypes[3] = TrackTypes.PROMO;
TrackTypes[4] = TrackTypes.VOICE_TRACK;
TrackTypes[5] = TrackTypes.PODCAST;
TrackTypes[9] = TrackTypes.FILLER;

export default { ScheduledItemTypes, TrackTypes };